import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=481eb654&scoped=true&"
import script from "./VInput.vue?vue&type=script&lang=js&"
export * from "./VInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481eb654",
  null
  
)

export default component.exports